<div id="content" class="allcp-form" ng-controller="RouteListController" ng-init="get()">
    <div ng-include="'modules/company/menus/order_menu.html'"></div>
    <div class="panel-body">
        <div class="row">
            <div class="col-md-6">
                <div class="panel-heading">
                    <span class="panel-title"> Edit Offer</span>
                    <hr>
                </div>
                <form ng-submit="update()" class="form-horizontal allcp-form">
                    <div class="form-group">
                        <div class="col-md-12">
                            <input id="date" type="text" class="gui-input br-light light" placeholder="Date" required ng-model="data.offer.date">
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-12">
                            <label for="field_type" class="field select">
                                <select id="type" name="type" ng-model="data.offer.station_id" required>
                                    <option value="">Select Station</option>
                                    <option value="{{ item.id }}" ng-repeat="item in data.stations">{{ item.code }}</option>
                                </select>
                                <i class="arrow"></i>
                            </label>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-6 pr-2">
                                    <input id="start" type="text" class="gui-input br-light light" placeholder="Start Time" required ng-model="data.offer.start_time">
                                </div>
                                <div class="col-md-6 pl-2">
                                    <input id="end" type="text" class="gui-input br-light light" placeholder="End Time" required ng-model="data.offer.end_time">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-12">
                            <label for="label" class="field">
                                <input type="text" ng-model="data.offer.price" class="gui-input br-light light" placeholder="Offer Price" required>
                            </label>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-12">
                            <label for="label" class="field">
                                <input type="text" ng-model="data.offer.worker_count" class="gui-input br-light light" placeholder="Offer Count" required>
                            </label>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-12">
                            <label for="field_type" class="field select">
                                <select id="type" name="type" ng-model="data.offer.wehicle" required>
                                    <option value="">Select Wehicle</option>
                                    <option value="Small">Small</option>
                                    <option value="Medium">Medium</option>
                                    <option value="Large">Large</option>
                                </select>
                                <i class="arrow"></i>
                            </label>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-12">
                            <button type="submit" class="btn btn-primary pull-right"><span class="fa fa-edit"></span> Update</a>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-md-6">
                <div class="panel-heading">
                    <span class="panel-title"> Applications</span>
                    <hr>
                </div>
                <div class="table-responsive" ng-if="data.offer.workers.length > 0">
                    <table class="table table-hover tc-checkbox-1 fs13">
                        <thead class="p20">
                            <tr class="bg-light">
                                <th class="text-center">#</th>
                                <th>Image</th>
                                <th>
                                    <a href="#" ng-click="sortType = 'user.full_name'; sortReverse = !sortReverse">
                                        Full Name
                                        <span ng-show="(sortType == 'user.full_name' && !sortReverse ) || true" class="fa fa-sort-alpha-desc"></span>
                                        <span ng-show="sortType == 'user.full_name' && sortReverse" class="fa fa-sort-alpha-asc"></span>
                                    </a>
                                </th>
                                <th>
                                    <a href="#" ng-click="sortType = 'email'; sortReverse = !sortReverse">
                                        Email
                                        <span ng-show="(sortType == 'email' && !sortReverse ) || true" class="fa fa-sort-alpha-desc"></span>
                                        <span ng-show="sortType == 'email' && sortReverse" class="fa fa-sort-alpha-asc"></span>
                                    </a>
                                </th>
                                <th>
                                    <a href="#" ng-click="sortType = 'phone_number'; sortReverse = !sortReverse">
                                        Phone Number
                                        <span ng-show="(sortType == 'phone_number' && !sortReverse ) || true" class="fa fa-sort-alpha-desc"></span>
                                        <span ng-show="sortType == 'phone_number' && sortReverse" class="fa fa-sort-alpha-asc"></span>
                                    </a>
                                </th>
                                <th>
                                    <a href="#" ng-click="sortType = 'device'; sortReverse = !sortReverse">
                                        Cihaz
                                        <span ng-show="(sortType == 'device' && !sortReverse ) || true" class="fa fa-sort-alpha-desc"></span>
                                        <span ng-show="sortType == 'device' && sortReverse" class="fa fa-sort-alpha-asc"></span>
                                    </a>
                                </th>
                                <th>
                                    <a href="#" ng-click="sortType = 'app_version'; sortReverse = !sortReverse">
                                        Version
                                        <span ng-show="(sortType == 'app_version' && !sortReverse ) || true" class="fa fa-sort-alpha-desc"></span>
                                        <span ng-show="sortType == 'app_version' && sortReverse" class="fa fa-sort-alpha-asc"></span>
                                    </a>
                                </th>
                                <th>
                                    <a href="#" ng-click="sortType = 'type'; sortReverse = !sortReverse">
                                        Type
                                        <span ng-show="(sortType == 'type' && !sortReverse ) || true" class="fa fa-sort-alpha-desc"></span>
                                        <span ng-show="sortType == 'type' && sortReverse" class="fa fa-sort-alpha-asc"></span>
                                    </a>
                                </th>
                                <th>
                                    <a href="#" ng-click="sortType = 'status'; sortReverse = !sortReverse">
                                        Status
                                        <span ng-show="(sortType == 'status' && !sortReverse ) || true" class="fa fa-sort-alpha-desc"></span>
                                        <span ng-show="sortType == 'status' && sortReverse" class="fa fa-sort-alpha-asc"></span>
                                    </a>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-left" ng-repeat="item in data.offer.workers | filter: data.term | orderBy:sortType:sortReverse ">
                                <td>
                                    <label class="option block mn">
                                        <input type="checkbox" name="deleted[]" ng-checked="deleted.indexOf(item.id) > -1" ng-click="toggleSelection(item.id)">
                                        <span class="checkbox mn"></span>
                                    </label>
                                </td>
                                <td class="clickable-row text-center w50" ng-click="getWorkerDetails(item.worker.id)">
                                    <img ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ item.worker.profile_photo }}" class="img-responsive text-center img-circle" width="36px" height="36px" style="width:36px;  height:36px;" alt="">
                                </td>
                                <td class="clickable-row" ng-click="getWorkerDetails(item.worker.id)">{{ item.worker.user.email}}</td>
                                <td class="clickable-row" ng-click="getWorkerDetails(item.worker.id)">{{ item.worker.user.full_name}}</td>
                                <td class="clickable-row" ng-click="getWorkerDetails(item.worker.id)">{{ item.worker.phone_number }}</td>
                                <td class="clickable-row" ng-click="getWorkerDetails(item.worker.id)">{{ item.worker.device }}</td>
                                <td class="clickable-row" ng-click="getWorkerDetails(item.worker.id)">{{ item.worker.version }}</td>
                                <td class="clickable-row" ng-click="getWorkerDetails(item.worker.id)">
                                    <i class="fa fa-truck fs24" ng-if="item.worker.type == 'truck'"></i>
                                    <i class="fa fa-automobile fs24" ng-if="item.worker.type == 'automobile'"></i>
                                    <i class="fa fa-motorcycle fs24" ng-if="item.worker.type == 'motorcycle'"></i>
                                    <i class="fa fa-bicycle fs24" ng-if="item.worker.type == 'bicycle'"></i>
                                    <i class="fa fa-male fs24" ng-if="item.worker.type == 'walking'"></i>
                                    <i class="fa fa-user fs24" ng-if="item.worker.type == 'office'"></i>
                                </td>
                                <td ng-click="getWorkerDetails(item.worker.id)">
                                    <span class="label label-success" ng-if="item.worker.status == 1">ONLINE</span>
                                    <span class="label label-success" ng-if="item.worker.status == 1">OFFLINE</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="text-center mt50" ng-if="data.offer.workers.length == 0">
                    <img src="img/empty_page_orange.svg" alt="" width="400px">
                    <br>
                    <h3 style="font-size: 48px;font-weight: 800;">Application not found</h3>
                </div>
            </div>
        </div>
    </div>
</div>